import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { INDIVIDUAL_RECIPIENT_MEMBER_COUNT } from '../constants';
import { isIndividualRecipient } from './isIndividualRecipient';

export function getInvididualRecipients(
    recipientInfo: SharingTipRecipientInfo[]
): SharingTipRecipientInfo[] {
    return recipientInfo.filter(
        info =>
            info.totalMemberCount === INDIVIDUAL_RECIPIENT_MEMBER_COUNT &&
            isIndividualRecipient(info.recipient.persona.EmailAddress.MailboxType)
    );
}
